import {PureComponent} from 'react';
import {connect} from "react-redux";

class Authenticated extends PureComponent {
    constructor(...args) {
        super(...args);
        this._isAllowed = false;
    }

    get allowed() {
        return this._isAllowed;
    }

    isAllowed() {
        let allowed = !!this.props.authenticated;
        return (!!this.props.not ? !allowed : allowed);
    }

    render() {
        this._isAllowed = this.isAllowed();
        return !!this.props.passThrough || this._isAllowed ? this.renderChildren() : null;
    }

    renderChildren() {
        const {children} = this.props;
        return typeof children === 'function'
            ? children(this._isAllowed)
            : children;
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: state.currentUser.initialized
    }
};

export default connect(mapStateToProps, null, null, {forwardRef: true})(Authenticated);

